import { tmsBaseUrl } from '@app/sdk';

export const merchantBaseUrl = `${tmsBaseUrl}/merchant-service`;
export const tenantHierarchyBaseUrl = `${tmsBaseUrl}/tenant-hierarchy-service`;
export const productBaseUrl = `${tmsBaseUrl}/product-service`;
export const referenceDataBaseUrl = `${tmsBaseUrl}/reference-data-service`;
export const brandBaseUrl = `${tmsBaseUrl}/brand-service`;
